import { useNotify, useRedirect } from "ra-core";
import HiddenInputRA from "../components/HiddenInputRA";

import AuthorizeInput from "../components/AuthorizeInput";
import TextInputRA from "../components/TextInputRA";
import { Box, Grid } from "@material-ui/core";
import LayoutContainer from "../components/LayoutContainer";
import LeftGridEdit from "../components/LeftGridEdit";
import RightGridEdit from "../components/RightGridEdit";
import RoleValidation from "../../../ValidationRules/RoleValidation";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";
import { Loading } from "react-admin";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
// //Manipulate outdated data
const transform = (data) => {
  if (data.authorizes) {
    data.authorizes = data.authorizes.map((auth) => {
      return { object_code: auth.code, ...auth }; //Make backward compatible
    });
    data.authorizes = data.authorizes.filter(
      (auth) => auth.action_codes.length > 0
    );
  }

  return { ...data };
};

const UserEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Product",
    write: true,
  });
  if (loading) return <Loading />;
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };
  /*
  const transform = (data) => {
    alert("Run transform " + JSON.stringify(data));
    if (data.identification?.employee_no) {
      alert(data.identification?.employee_no);

      return {
        ...data,
        employee_no: data.identification.employee_no,
      };
    }
    alert("มุแง้");
    return { ...data };
  };*/

  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
       <LeftGridEdit
          onSuccess={onSuccess}
          onFailure={onFailure}
          {...props}
          validate={RoleValidation}
          transform={transform}
          disabled={!allow}
        >
          <SfBreadcrumbs path="Management/Roles" lower />
          <Box style={{ margin: 50 }}>
            <TextInputRA required label="Name" source="name" />
            <TextInputRA label="Description" source="desc" />
          </Box>
          <AuthorizeInput />
          <HiddenInputRA source="status" initialValue="Active" />
        </LeftGridEdit>
        <RightGridEdit {...props} noImage />
      </Grid>
      {/* <Edit
        mutationMode="pessimistic"
        onSuccess={onSuccess}
        onFailure={onFailure}
        {...props}
      >
        <SimpleForm>
          <TextInputRA label="Name" source="name" />
          <TextInputRA label="Description" source="desc" />
          <HiddenInputRA source="status" initialValue="Active" />
          <AuthorizeInput />
        </SimpleForm>
      </Edit> */}
    </LayoutContainer>
  );
};

export default UserEdit;
